import { createSelector, createSelectorCreator } from 'reselect';
import memoize from 'lodash/memoize';
import { InfiniteArray } from '../helpers/infinite-array';
import { LINEAR_CHANNELS_STATE_STATUSES } from '../../linearChannels/constants';

function* getPartialList(list, firstIndex, lastIndex) {
  const infiniteList = new InfiniteArray(list);
  let currentIndex = firstIndex;
  while (currentIndex < lastIndex) {
    yield infiniteList.get(currentIndex);
    currentIndex += 1;
  }
}

const hashFn = (...args) => args.reduce((acc, val) => `${acc}-${JSON.stringify(val)}`, '');
const customSelectorCreator = createSelectorCreator(memoize, hashFn);

const guideListPropSelector = (state) => state.guide.list;
const guideSelectedIndexSelector = (state) => state.guide.selectedIndex;
const startIndexSelector = (_, props) => props.startIndex;
const endIndexSelector = (_, props) => props.endIndex;

const listSelector = customSelectorCreator(
  [guideListPropSelector, guideSelectedIndexSelector, startIndexSelector, endIndexSelector],
  (list, selectedIndex, startIndex, endIndex) => {
    let generatedList = [];
    if (list.length > 0 && selectedIndex >= 0) {
      generatedList = [...getPartialList(list, startIndex, endIndex)];
    }
    return generatedList;
  },
);

const linearChannelsStatusSelector = (state) => state.linearChannels.status;
const linearChannelsResultSelector = (state) => state.linearChannels.result;

const haveLinearChannelsSelector = createSelector(
  [linearChannelsStatusSelector, linearChannelsResultSelector],
  (status, result) => {
    const isDone = status === LINEAR_CHANNELS_STATE_STATUSES.DONE;
    const haveItems = result && result.length > 0;

    return isDone && haveItems;
  },
);

export const guideListSelector = customSelectorCreator(
  [listSelector, haveLinearChannelsSelector, startIndexSelector, endIndexSelector],
  (list, haveLinearChannels) => {
    let finalList = [];
    if (haveLinearChannels) {
      finalList = list;
    }
    return finalList;
  },
);
